import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  partnersEventsApi,
  partnersEventsApiKeys,
  type PartnerEventsListParams,
} from '@/api/routes/partners/partners.events.api';

/** One page of the partner's events, with the per-tab counts. Keeps the page while a tab loads. */
export const usePartnersReadEvents = (params: PartnerEventsListParams) => {
  return useQuery({
    queryKey: partnersEventsApiKeys.list(params),
    queryFn: () => partnersEventsApi.list(params).then((res) => res.data),
    placeholderData: keepPreviousData,
  });
};
